import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { createComponentsFromObject } from 'conversional-components';
import { createTheme, defaultTheme } from 'conversional-theme';
import { useListener } from '../utils/listener';
/**
 * Preview
 */
var Preview = function () {
    /**
     * The content and theme that user wants to render in the preview instance
     * will be stored as a state variable in this component. Because there is no need to globalize
     * these two variables and storing in redux could cause more complexity.
     *
     * There are two listeners waiting for theme/content change. Whenever user invokes previewer.changeContent(), a message with
     * type=MESSAGETYPES.CHANGE_CONFIG will be casted in the message hub. In that way this component can find out when
     * the user wants to change the configuration of the dynamic component builder.
     * */
    var _a = React.useState({}), config = _a[0], setConfig = _a[1];
    var _b = React.useState(defaultTheme), theme = _b[0], setTheme = _b[1];
    useEffect(function () {
        sendToHost.publish(MESSAGETYPES.PREVIEW_READY);
        sendToHost.styleIframe({ width: 700, height: 400 });
    }, []);
    var onConfigChange = function (_a) {
        var content = _a.content;
        setConfig(content);
    };
    var onThemeChange = function (_a) {
        var content = _a.content;
        setTheme(createTheme(content));
    };
    useListener(MESSAGETYPES.CHANGE_CONFIG, onConfigChange);
    useListener(MESSAGETYPES.CHANGE_THEME, onThemeChange);
    return _jsx(_Fragment, { children: createComponentsFromObject(config) });
};
export default Preview;
